import { useEffect, useState } from 'react'
import { getCatalogue } from '@/lib/api'
import type { Perfume, Collection } from '@/types'

export function useCatalogue() {
  const [products, setProducts] = useState<Perfume[]>([])
  const [collections, setCollections] = useState<Collection[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    getCatalogue()
      .then((data) => {
        if (!mounted) return
        setProducts(data.products)
        setCollections(data.collections)
        setError(null)
      })
      .catch((err) => {
        if (!mounted) return
        setError(err instanceof Error ? err.message : 'Failed to load catalogue')
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  return { products, collections, loading, error }
}
